import i18n from "../i18nt";
const isoKey = "pages.licence.iso";
const licenceKey = "pages.licence.licence";
const solutionKey = "pages.licence.solution";
import Iso1 from '../assets/pages/licences/ISO14001.jpg';
import Iso2 from '../assets/pages/licences/ISO45001.jpg';
import Iso3 from '../assets/pages/licences/ISO9001.jpg';
import Licence1 from '../assets/pages/licences/Licenca-hemijske-i-fizicke-stetnosti.jpg';
import Licence2 from '../assets/pages/licences/licenca-pregled-i-provera-opreme-za-rad-i-ispitivanje-el-i-gromobranskih-instalacija.jpg';
import Licence3 from '../assets/pages/licences/licenca-BPCP-za-BZR.jpg';
import Solution1 from '../assets/pages/licences/Resenje-ZOP.jpg';

export const licences = [
    {
        id: 1,
        title: i18n.t( `${ isoKey }.item1.title` ),
        imageUrl: Iso1,
        pdfLink: "/pdf/ISO_14001.pdf"
    },
    {
        id: 2,
        title: i18n.t( `${ isoKey }.item2.title` ),
        imageUrl: Iso2,
        pdfLink: "/pdf/ISO_45001.pdf"
    },
    {
        id: 3,
        title: i18n.t( `${ isoKey }.item3.title` ),
        imageUrl: Iso3,
        pdfLink: "/pdf/ISO_9001.pdf"
    },
    {
        id: 4,
        title: i18n.t( `${ licenceKey }.item1.title` ),
        imageUrl: Licence1,
        pdfLink: "/pdf/Licenca _hemijske_i_fizičke_štetnosti.pdf"
    },
    {
        id: 5,
        title: i18n.t( `${ licenceKey }.item2.title` ),
        imageUrl: Licence2,
        pdfLink: "/pdf/LICENCA_PREGLED_I_PROVERA_OPREME_ZA_RAD_I_ISPITIVANJE_EL_I_GROMOBRANSKIH_INSTALACIJA.pdf"
    },
    {
        id: 6,
        title: i18n.t( `${ licenceKey }.item3.title` ),
        imageUrl: Licence3,
        pdfLink: "/pdf/Licenca_BPCP_za_BZR.pdf"
    },
    {
        id: 7,
        title: i18n.t( `${ solutionKey }.item1.title` ),
        imageUrl: Solution1,
        pdfLink: "/pdf/Resenje_ZOP.pdf"
    },
];